import React, {Fragment} from "react";
import {Button, Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {rankList} from '../shared/shared';
import {getData} from "../../../api/doLogin";

export function DependentsInfo(props) {
  const {values, handleCB, readonly, token, formFields} = props;

  function setIndexFieldValue(value, field, index) {
    if (readonly) return;
    values[index][field] = value;
    handleCB(values);
  };

  function addDependent() {
    if (readonly) return;
    values.push({});
    handleCB(values);
  };

  function deleteDependent(index){
    if (readonly) return;
    values.splice(index,1);
    handleCB(values);
  }

  function buildRank(branch) {
    let rankArray = rankList(branch) || [];
    return rankArray.map((value, index) => {
      return (
        <option key={index + 1} value={value}>{value}</option>
      );
    });
  }

  function getFormFieldValue(val) {
    if (val != null) {
      return val;
    } else {
      return "";
    }
  };

  function fetchZipDetails(zip, city, state) {
    if (readonly) return;
    if (zip.length === 0) {
      var objPost = {
        ...values,
        [city]: "",
        [state]: ""
      }
      handleCB(objPost);
      return;
    }
    getData("zip/get?zip=" + zip, {}, token)
      .then((data) => {
        if (data.status == "Success") {
          console.log(data.data);
          if (data.data.zipDetails.hasOwnProperty("city") && data.data.zipDetails.hasOwnProperty("state")) {
            var objPost = {
              ...values,
              [city]: data.data.zipDetails.city,
              [state]: data.data.zipDetails.state
            }
            handleCB(objPost);
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };
  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h2>Dependent Information</h2>
        </Col>
      </Row>
      {values.map((dep, index) => {
        return (
          <Fragment key={index}>
            <Row>
              <Col xs={"1"}>
                <h5>#{index + 1}</h5>
              </Col>
              <Col xs={"3"}>
                <FormGroup>
                  <Label htmlFor="fname">First&nbsp;Name*</Label>
                  <Input type="text" id="fname" placeholder=""
                         value={getFormFieldValue(dep.fname)}
                         onChange={(evt) => setIndexFieldValue(evt.target.value, evt.target.id, index)}/>
                </FormGroup>
              </Col>
              <Col xs={"2"}>
                <FormGroup>
                  <Label htmlFor="middleInitial">Middle&nbsp;Initial</Label>
                  <Input type="text" id="middleInitial" placeholder=""
                         value={getFormFieldValue(dep.middleInitial)}
                         onChange={(evt) => setIndexFieldValue(evt.target.value, evt.target.id, index)}/>
                </FormGroup>
              </Col>
              <Col xs={"3"}>
                <FormGroup>
                  <Label htmlFor="lname">Last&nbsp;Name*</Label>
                  <Input type="text" id="lname" placeholder=""
                         value={getFormFieldValue(dep.lname)}
                         onChange={(evt) => setIndexFieldValue(evt.target.value, evt.target.id, index)}/>
                </FormGroup>
              </Col>
              <Col xs={"2"}>
                <FormGroup>
                  <Label htmlFor="gender">Gender*</Label>
                  <Input type="select" name="gender" id="gender"
                         value={getFormFieldValue(dep.gender)}
                         onChange={(evt) => setIndexFieldValue(evt.target.value, evt.target.id, index)}>
                    <option key={0} value={""} disabled={true}>Choose</option>
                    <option key={1} value={"M"}>M</option>
                    <option key={2} value={"F"}>F</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={"1"}>
                <Button color={"danger"} onClick={(evt) => deleteDependent(index)}>Delete</Button>
              </Col>
              <Col xs={"3"}>
                <FormGroup>
                  <Label htmlFor="bdate">Date of Birth*</Label>
                  <TextMask
                    mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
                    Component={InputAdapter}
                    className="form-control"
                    id="bdate"
                    value={getFormFieldValue(dep.bdate)}
                    onChange={(evt) => setIndexFieldValue(evt.target.value, evt.target.id, index)}
                  />
                  <FormText color="muted">
                    MM/DD/YYYY (ex. 08/26/1984)
                  </FormText>
                </FormGroup>
              </Col>
              <Col xs={"3"}>
                <FormGroup>
                  <Label htmlFor="ssn">SSN</Label>
                  <TextMask
                    mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    Component={InputAdapter}
                    className="form-control"
                    id={"ssn"}
                    value={getFormFieldValue(dep.ssn)}
                    onChange={(evt) => setIndexFieldValue(evt.target.value, evt.target.id, index)}
                  />
                  <FormText color="muted">
                    ex. 999-99-9999
                  </FormText>
                </FormGroup>
              </Col>
            </Row>
          </Fragment>
        )
      })}


      <Row>
        <Col xs={"4"}>
          <Button onClick={(evt) => addDependent()}>Add Dependent</Button>
        </Col>
      </Row>

    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/DependentsInfo.js